<template>
  <footer class="home-footer home__footer">
    <div class="home-footer__container">
      <!-- <div class="home-footer__content"> -->
        <!-- <div class="home-footer__item home-footer__first"> -->
          <!-- <ul>
            <li>
              <div class="home-header__item home-header__logo">
                <img src="@/assets/logofone.png" />
                <h3>Океан<span> Слов</span></h3>
              </div>
            </li> -->
            <!-- <li class="home-footer__socials">
              <router-link to="/">
                <img class="home-footer__socials-fc" src="@/assets/facebook.png" alt="facebook" />
              </router-link>
              <router-link to="/">
                <img src="@/assets/twitter.png" alt="twitter" />
              </router-link>
              <router-link to="/">
                <img src="@/assets/google.png" alt="google" />
              </router-link>
            </li> -->
          <!-- </ul>
        </div> -->
        <!-- <div class="home-footer__item">
          <h2>Мои ссылки</h2>
          <ul>
            <li>
              <a href="https://github.com/IFraimG/learning-english-words">Репозиторий проекта</a>
            </li>
            <li>
              <a href="https://github.com/IFraimG">Мой Github</a>
            </li>
            <li>
              <a href="https://habr.com/ru/users/IFraim/">Habr аккаунт</a>
            </li>
          </ul>
        </div> -->
        <!-- <div class="home-footer__item">
          <h2>Our Services</h2>
          <ul>
            <li>About Us</li>
            <li>Our Services</li>
            <li>Our Plan</li>
            <li>Our Team</li>
            <li>Latest News</li>
          </ul>
        </div>
        <div class="home-footer__item">
          <h2>Contact Us</h2>
          <ul>
            <li>About Us</li>
            <li>Our Services</li>
            <li>Our Plan</li>
            <li>Our Team</li>
            <li>Latest News</li>
          </ul>
        </div> -->
      <!-- </div> -->
      <div class="home-header__item home-header__logo">
        <img src="@/assets/logofone.png" />
        <h3>Океан<span> Слов</span></h3>
        </div>
      <p class="home-footer__copyright">Copyright © IFraimTeam 2021-2023. All Rights Reserved.</p>
    </div>
  </footer>
</template>

<script>
  import "@/components/app/scss/home/Home.scss"

  export default {
    name: "Footer",
  }
</script>
